export default {
  title: "",
  subtitle: "Exchange/Conversion",
  path: "transaction_status_exchange",
  paragraph: "",
  request: {},
   domainsProperties: [
    {
      name: "exchanged",
      values: "means the conversion rate has been closed, and therefore, the exchanged value is defined - when the destination is to an internal bank account, this is the final state."
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionsStatusExchange.js